// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"EditCspPage_pageContainer__13rRI","secondaryPageContainer":"EditCspPage_secondaryPageContainer__5-BLM"};